import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
import tim from './tim.js'
import TIM from 'tim-js-sdk/tim-js-friendship.js'
import './plugins/vant.js'
// 仅引入用到的图标以减小打包体积
import 'vue-awesome/icons/microphone'
import 'vue-awesome/icons/microphone-slash'
import 'vue-awesome/icons/video'
import 'vue-awesome/icons/video-slash'
import Icon from 'vue-awesome/components/Icon'
import {getQueryString} from "@/utils/common";
import './assets/less/global.less'

Vue.config.productionTip = false
window.tim = tim
Vue.prototype.tim = tim
Vue.prototype.TIM = TIM
Vue.prototype.$store = store
Vue.prototype.$bus = new Vue()
Vue.prototype.$njws = new WebSocket(process.env.VUE_APP_WEBSOCKET);
Vue.prototype.$jobfairId = getQueryString('id')
Vue.prototype.$window = window
Vue.use(VueCookies)
Vue.component('v-icon', Icon)
Vue.$cookies.config('1d','/')

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
